import { Component, OnInit, ViewChild } from '@angular/core';
import { ABMRolesService } from '../../../services/abm-roles-service';
import { DialogsService } from '../../../services/dialogs-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from '../../../services/navigation-service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { TableDataSource } from '../../../utils';
import {
  PATH_ABM,
  PATH_ABM_NUEVO_ROL,
  PATH_ABM_ROL_DETAIL,
  PATH_BUSCADOR,
  PATH_CONSIGNA_DETAIL,
  PATH_ABM_ACOPIO_DETAIL,
  PATH_ABM_CATEGORIA_DETAIL, PATH_BUSCADOR_COLABORADORES, PATH_NEW_PERMISO
} from '../../../navigation/navigation.module';
import {ColaboradoresListComponent} from '../colaboradores/colaboradores-list/colaboradores-list.component';
import { PermisosService } from '../../../services/permisos-service';
import { EntidadesFinancierasComponent } from '../entidades-financieras/entidades-financieras.component';
import {environment} from '../../../../environments/environment';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';

@Component({
  selector: 'app-abm',
  templateUrl: './abm.component.html',
  styleUrls: ['./abm.component.scss']
})
export class ABMComponent implements OnInit {

  productosSubject$ = new BehaviorSubject<any[]>([]);
  productosDataSource = new TableDataSource(this.productosSubject$);
  productosDisplayedColumns = ['Producto'];
  productosPage = 0;
  productosResponseData = [];
  newProdDialogResponse: any;
  editProductoDialogResponse: any;

  rolesSubject$ = new BehaviorSubject<any[]>([]);
  rolesDataSource = new TableDataSource(this.rolesSubject$);
  rolesDisplayedColumns = ['fullName', 'actions'];
  rolesPage = 0;
  rolesResponseData = [];

  categoriasSubject$ = new BehaviorSubject<any[]>([]);
  categoriasDataSource = new TableDataSource(this.categoriasSubject$);
  categoriasDisplayedColumns = ['fullName', 'actions'];
  categoriasPage = 0;
  categoriasResponseData = [];

  acopiosSubject$ = new BehaviorSubject<any[]>([]);
  acopiosDataSource = new TableDataSource(this.acopiosSubject$);
  acopiosDisplayedColumns = ['fullName', 'actions'];
  acopiosPage = 0;
  acopiosResponseData = [];

  selectedTabIndex = 0;
  COLABORADORES_TAB = 0;
  ROLES_TAB= 1;
  CATEGORIAS_TAB = 2;
  ACOPIOS_TAB = 3;
  PERMISOS_TAB = 4;
  ENTIDADES_TAB = 5;
  MERCADOS_TAB = 6;
  PRODUCTOS_TAB = 7;

  @ViewChild(ColaboradoresListComponent) colaboradoresComponent;
  @ViewChild(EntidadesFinancierasComponent) entidadesComponent;

  private selectedColaboradoresArray = [];
  private selectedCategoriasArray = [];
  private selectedCuentasArray = [];

  constructor(private route: ActivatedRoute,
    private abmRolesService: ABMRolesService,
    private location: Location,
    private dialogsService: DialogsService,
    private navigationService: NavigationService,
    private router: Router,
    private permisosService: PermisosService,
    private firebaseService: FirebaseMessagingService,
  ) {
    this.permisosService.verificarAccesoDeURL();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const page = this.route.snapshot.params['page'];

      switch (page) {
        case 'colaboradores':
          this.selectedTabIndex = 0;
          break;
        case 'roles':
          this.selectedTabIndex = 1;
          break;
        case 'categorias':
          this.selectedTabIndex = 2;
          break;
        case 'acopios':
          this.selectedTabIndex = 3;
          break;
        case 'permisos':
          this.selectedTabIndex = 4;
          break;
        case 'entidades-financieras':
		  this.selectedTabIndex = 5;
          break;
        case 'mercados':
          this.selectedTabIndex = 6;
          break;
        case 'productos':
          this.selectedTabIndex = 7;
          break;
        default:
          this.selectedTabIndex = 0;
          break;
      }

      this.loadData();
    });
  }

  loadData() {
    switch (this.selectedTabIndex) {
      case 1:
        if (this.rolesResponseData.length <= 0) {
          this.getRoles();
        }
        break;
      case 2:
        if (this.categoriasResponseData.length <= 0) {
          this.getCategorias();
        }
        break;
      case 3:
        if (this.acopiosResponseData.length <= 0) {
          this.getAcopios();
        }
        break;
      case 6:
        if (this.productosResponseData.length <= 0) {
          this.getProductos();
        }
        break;
      default:
        this.getRoles();
    }
  }

  getRoles(){
    this.abmRolesService.getRoles()
    .subscribe( data => {
      this.rolesResponseData = data;
      this.rolesSubject$.next(this.rolesResponseData);
    });
  }

  getCategorias(){
    this.abmRolesService.getCategorias()
    .subscribe( data => {
      this.categoriasResponseData = data;
      this.categoriasSubject$.next(this.categoriasResponseData);
    });
  }

  getAcopios(){
    this.abmRolesService.getAcopios()
    .subscribe( data => {
      this.acopiosResponseData = data;
      this.acopiosSubject$.next(this.acopiosResponseData);
    });
  }

  getProductos () {
    this.abmRolesService.getProductos()
      .subscribe( data => {
        this.productosResponseData = data;
        this.productosSubject$.next(this.productosResponseData);
      });
  }

  onActivateRol(rol, activate: boolean){
  this.dialogsService.confirm(null,
                activate ? "¿Está seguro de que desea activar este rol?" : "¿Está seguro de que desea desactivar este rol?",
                activate ? "SÍ, ACTIVAR" : "SÍ, DESACTIVAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.abmRolesService.activateRol(rol.RolId)
            .subscribe( data => {
              if (data.ResponseData){

                for (let value of this.rolesResponseData){
                  if (value.RolId === rol.RolId){
                    value.Habilitada = activate;
                    this.rolesSubject$.next(this.rolesResponseData);
                    return;
                  }
                }
              }
            });
        }});
  }

  onEditRol(rol){

  }

  onActivateCategoria(categoria, activate: boolean){
  this.dialogsService.confirm(null,
                activate ? "¿Está seguro de que desea activar esta categoría?" : "¿Está seguro de que desea desactivar esta categoría?",
                activate ? "SÍ, ACTIVAR" : "SÍ, DESACTIVAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.abmRolesService.activateCategoria(categoria.Id)
            .subscribe( data => {
              if (data.ResponseData){

                for (let value of this.categoriasResponseData){
                  if (value.Id === categoria.Id){
                    value.Habilitada = activate;
                    this.categoriasSubject$.next(this.categoriasResponseData);
                    return;
                  }
                }
              }
            });
        }});
  }

  onActivateAcopio(acopio, activate: boolean){
  this.dialogsService.confirm(null,
                activate ? "¿Está seguro de que desea activar este acopio?" : "¿Está seguro de que desea desactivar este acopio?",
                activate ? "SÍ, ACTIVAR" : "SÍ, DESACTIVAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.abmRolesService.activateAcopio(acopio.Id)
            .subscribe( data => {
              if (data.ResponseData){

                for (let value of this.acopiosResponseData){
                  if (value.Id === acopio.Id){
                    value.Habilitada = activate;
                    this.acopiosSubject$.next(this.acopiosResponseData);
                    return;
                  }
                }
              }
            });
        }});
  }

  onUpdatePlanComercial(acopio, activate: boolean) {
    this.dialogsService.confirm(
      null,
      activate 
        ? "¿Está seguro de que desea activar Plan Comercial para este acopio?" 
        : "¿Está seguro de que desea desactivar Plan Comercial para este acopio?",
      activate ? "SÍ, ACTIVAR" : "SÍ, DESACTIVAR",
      "NO, CANCELAR"
    ).subscribe(res => {
      if (res) {
        this.abmRolesService.updatePlanComercial(acopio.Id, activate)
          .subscribe( data => {
            if (data) {
              const newData = this.acopiosResponseData;
              const index = newData.findIndex(x => x.Id === acopio.Id);
              newData[index].PlanComercialVisibility = activate;
              this.acopiosSubject$.next(newData)
            }
          });
      }
    })
  }

  onRolSelected(rol){
    this.router.navigate([PATH_ABM_ROL_DETAIL, rol.Id]);
  }

  onAcopioSelected(acopio){
    this.router.navigate([PATH_ABM_ACOPIO_DETAIL, acopio.Id]);
  }

  onAddParentAcopio(acopio){
    //esto se hace para obtener siempre la ultima actualizacion del acopio, para no recargar toda la tab
    this.abmRolesService.getAcopioById(acopio.Id).subscribe(data => {
      this.dialogsService.editAcopioDialog(data);
    });
  }

  onCategoriaSelected(categoria){
    this.router.navigate([PATH_ABM_CATEGORIA_DETAIL, categoria.Id]);
  }

  NuevoEditProducto(selectedProducto: any) {
    this.dialogsService.showEditProductoDialog(selectedProducto, this.productosResponseData)
      .subscribe( value => {
        if (value) {
          this.getProductos();
        }
      });
  }

  toggleNav(){
    this.navigationService.toggleNav(true);
  }

  navigateToBuscador(){
    this.router.navigate([PATH_BUSCADOR]);
  }

  navigateToNuevoRol(){
    this.router.navigate([PATH_ABM_NUEVO_ROL]);
  }

  navigateToNuevoAcopio(){
    this.dialogsService.showNewAcopioDialog()
      .subscribe( value => {
        // TODO: recargar listado de acopios en creación exitosa
      })
  }

  navigateToNuevaCategoria(){
    this.dialogsService.showNewCategoriaDialog()
      .subscribe( value => {
        // TODO: recargar listado de categorias en creación exitosa
      });
  }

  onSelectedTabChange(e) {
    const pages = ['/colaboradores', '/roles', '/categorias', '/acopios', '/permisos', '/entidades-financieras', '/mercados', '/productos'];
    this.location.go(PATH_ABM + pages[e.index]);

    if (e.index === 1 && this.rolesResponseData.length <= 0) {
      this.getRoles();
    } else if (e.index === 2 && this.categoriasResponseData.length <= 0) {
      this.getCategorias();
    } else if (e.index === 3 && this.acopiosResponseData.length <= 0) {
      this.getAcopios();
    } else if (e.index === 7 && this.productosResponseData.length <= 0) {
      this.getProductos();
    }

    // Analytics
    this.firebaseService.sendToAnalytics(PATH_ABM + pages[e.index]);
  }

  onRolesFiltersApplied($event){
    this.abmRolesService.getRoles()
    .subscribe( data => {
      this.rolesResponseData = data;
      this.rolesSubject$.next(this.rolesResponseData);
    });

    this.onFiltersApplied($event);
  }

  onFiltersApplied(event){

    this.selectedCuentasArray = event.cuentas.map(item => item.Id);
    this.selectedCategoriasArray = event.categorias.map(item => item.Id);
    this.selectedColaboradoresArray = event.colaboradores.map(item => item.UserId);

    this.getRolesFiltered();
  }

  getRolesFiltered(){
    this.abmRolesService.getRolesFiltered(this.selectedCuentasArray, this.selectedCategoriasArray, this.selectedColaboradoresArray)
    .subscribe( data => {
      this.rolesResponseData = data;
      this.rolesSubject$.next(this.rolesResponseData);
    });
  }

  onCreateColaborador() {
    this.colaboradoresComponent.showNewColaboradorDialog();
  }

  navigateToBuscadorColaboradores(){
    this.router.navigate([PATH_BUSCADOR, PATH_BUSCADOR_COLABORADORES]);
  }

  onCreatePermiso() {
    this.router.navigate([PATH_NEW_PERMISO]);
  }

  onCreateEntidad() {
    this.entidadesComponent.showNewEntidadDialog();
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abm/abm.component.ts